import { motion } from "framer-motion";
import { MousePointerClick, DollarSign, Users, Crown } from "lucide-react";

function Counter({ label, value, icon: Icon, color, testid, prefix = "", suffix = "" }) {
  return (
    <div
      data-testid={testid}
      className="relative overflow-hidden rounded-2xl border border-white/5 bg-void-card p-6"
    >
      <div className="absolute -top-16 -right-16 w-48 h-48 rounded-full opacity-20"
           style={{ background: `radial-gradient(circle, ${color}, transparent 60%)` }} />
      <div className="flex items-center gap-2 text-xs font-mono uppercase tracking-[0.25em] text-muted-foreground mb-4">
        <Icon className="w-3.5 h-3.5" style={{ color }} />
        {label}
      </div>
      <div className="font-mono text-3xl sm:text-4xl lg:text-5xl font-bold tabular-nums" style={{ color }}>
        {prefix}{value}{suffix}
      </div>
    </div>
  );
}

export default function GlobalCounters({ stats }) {
  const clicks = stats?.total_clicks_today ?? 0;
  const revenue = stats?.total_revenue_today ?? 0;
  const profilesCount = stats?.total_profiles ?? 0;
  const topBid = stats?.top_bid ?? 0;

  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.15 }}
      className="grid grid-cols-2 md:grid-cols-4 gap-4"
    >
      <Counter
        label="Total Clicks Today"
        value={clicks.toLocaleString()}
        icon={MousePointerClick}
        color="#00F0FF"
        testid="counter-total-clicks"
      />
      <Counter
        label="Current Ad Value"
        value={revenue.toFixed(2)}
        icon={DollarSign}
        color="#FAFF00"
        prefix="$"
        testid="counter-ad-value"
      />
      <Counter
        label="Active Profiles"
        value={profilesCount}
        icon={Users}
        color="#FF003C"
        testid="counter-profiles"
      />
      <Counter
        label="Top Bid"
        value={topBid.toFixed(2)}
        icon={Crown}
        color="#FFB800"
        prefix="$"
        testid="counter-top-bid"
      />
    </motion.div>
  );
}
